(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/high-five-next-race/views/promo-component.js') >= 0) return;  svs.modules.push('/components/racing/high-five-next-race/views/promo-component.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.racing=_svs.racing||{};
_svs.racing.high_five_next_race=_svs.racing.high_five_next_race||{};
_svs.racing.high_five_next_race.templates=_svs.racing.high_five_next_race.templates||{};
svs.racing.high_five_next_race.templates.promo_component = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"racing-promo-component-container\">\n  <div class=\"promo-container\"></div>\n</div>\n";
},"useData":true});
Handlebars.partials['components-racing-high_five_next_race-promo_component'] = svs.racing.high_five_next_race.templates.promo_component;
})(svs, Handlebars);


 })(window);